import { useMutation } from '@tanstack/react-query';

import {
  MutationFunction,
  useRequest,
  type ComponentQuantityData,
} from '@frontend/api';

export const useCreateQuantity: MutationFunction<
  ComponentQuantityData,
  {
    componentId: number;
    data: {
      quantity: number;
      isForFacilitatedOrder: boolean;
      manualLeadTime?: number | null;
      manualTotalUnitPrice?: string | null;
    };
  }
> = ({ requestOptions, queryOptions, query } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ componentId, data }) =>
      request(`/quotes/components/${componentId}/quantities`, {
        init: { method: 'POST', body: data },
        query,
      }),
    ...queryOptions,
  });
};
